import { motion } from "motion/react";
import { Link } from "react-router-dom";
import { STAR_PATH } from "@/components/brand/Logo";
import { EASE_EXPO } from "@/components/motion/primitives";

const BRAND_DARK = "#00332F";
const TEAL = "#2EE6D6";

/*
 * Students in Austria, winter semester 2024/25 (Statistik Austria, as cited
 * by OeAD): 369,858 in total, about 30 % international (≈ 111,000) and 32 %
 * of those from outside the EU (≈ 35,500). Update each autumn.
 */
const INTERNATIONAL = "Over 110,000";

/*
 * "Built for universities too": the offer to admissions offices, set where
 * students see it as well. It says what we do for universities, never that
 * any university works with us. Name one only after it has agreed, in
 * writing and only on /universities.
 */
export function ForUniversities() {
  return (
    <section className="bg-white px-3 py-8 sm:px-5 sm:py-10">
      <motion.div
        className="mx-auto max-w-[1240px] px-6 py-12 text-center sm:px-10 sm:py-16"
        style={{ backgroundColor: BRAND_DARK, borderRadius: 40 }}
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE_EXPO }}
      >
        <motion.span
          className="mx-auto flex h-14 w-14 items-center justify-center rounded-full sm:h-16 sm:w-16"
          style={{ backgroundColor: "rgba(46,230,214,0.14)" }}
          initial={{ scale: 0.6, rotate: -40, opacity: 0 }}
          whileInView={{ scale: 1, rotate: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ type: "spring", stiffness: 220, damping: 16, delay: 0.25 }}
          aria-hidden="true"
        >
          <svg viewBox="48 13 11 10.2" className="h-6 w-6 sm:h-7 sm:w-7">
            <path d={STAR_PATH} fill={TEAL} />
          </svg>
        </motion.span>
        <h2 className="mx-auto mt-6 font-black uppercase leading-[0.92] tracking-[-0.04em]" style={{ color: TEAL, fontSize: "clamp(2.1rem, 0.9rem + 3.6vw, 4.1rem)" }}>
          Built for universities too
        </h2>
        <p className="mx-auto mt-4 max-w-[58rem] text-[17px] font-medium leading-snug sm:text-[20px]" style={{ color: "rgba(255,255,255,0.85)" }}>
          {INTERNATIONAL} international students study in Austria. We get yours through the permit on time. We answer the visa questions your team hears every semester.
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-x-8 gap-y-4">
          <Link to="/universities" className="rounded-full px-8 py-4 text-[17px] font-bold transition-transform hover:-translate-y-0.5" style={{ backgroundColor: TEAL, color: BRAND_DARK }}>
            For universities
          </Link>
          <Link to={{ pathname: "/universities", hash: "#contact" }} className="text-[17px] font-bold text-white underline decoration-2 underline-offset-[6px] hover:decoration-[#2EE6D6]">
            Talk to us
          </Link>
        </div>
      </motion.div>
    </section>
  );
}
